import { FC, useState, useMemo } from 'react';
// Models
import IPrize from 'models/Prize';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
// Mui
import { MdStar, MdHelp } from 'react-icons/md';
import { Button } from './Buttons';
// i18next
import { useTranslation } from 'react-i18next';

const Prizes:FC = () => {
  const { t } = useTranslation('common');
  const limit = 3;
  // State
  const quiz:any = useAppSelector(selectQuiz);

  const [ itemsToShow, setItemsToShow ] = useState(limit);

  const totalPrizes:IPrize[] = useMemo(() => {
    const prizes = quiz.prizes || [];
    const spotPrizes = quiz.spotPrizesEnabled && quiz.spotPrizes ? quiz.spotPrizes : [];
    const prizesToObj = prizes.map((prize:string, index:number) => ({
      icon: () => (<MdStar />),
      iconColor: iconColor(index),
      text: prize
      }));
    const spotPrizesToObj = spotPrizes.map((prize:string) => ({
      icon: () => (<MdHelp />),
      iconColor: 'text-blue-500',
      text: prize
    }));
    return [...prizesToObj, ...spotPrizesToObj];
    // eslint-disable-next-line
  }, [quiz]);

  const toggleShowMore = () => {
    setItemsToShow(totalPrizes.length)
  }

  if ( !totalPrizes.length ) return null;
  return (
    <div className="flex flex-col justify-center items-center mb-4">
      <ul className="mb-4 px-4">
        {totalPrizes.slice(0, itemsToShow).map((prize:IPrize, index:number) => (
          <li
            key={`prize-item-${index}`}
            className="flex items-center py-2"
          >
            <div className={`
              w-10 h-10
              flex-shrink-0 flex justify-center items-center
              shadow-neu-content rounded-lg
              ${prize.iconColor} text-3xl leading-none
            `}>{prize.icon()}</div>
            <span className="pl-4">{prize.text}</span>
          </li>
        ))}
      </ul>
      {totalPrizes.length > itemsToShow ? (
        <Button
          onClick={toggleShowMore}
          size="small"
        >{t('components.prizes.showMorePrizes')}</Button>
      ) : null}
    </div>
  )
}

export default Prizes;

const iconColor = (index:number) => {
  switch (index){
    case 0:
      return 'text-yellow-500';
    case 1:
      return 'text-gray-400';
    case 2:
      return 'text-orange-800';
    default:
      return 'text-red-300';
  }
}
